
      import { Buffer } from "buffer";
      window.Buffer = window.Buffer || Buffer;

      var env = "qa"

      if(env !== 'release') {
        console.info(`environment: ${env}`)
      }
    